const MaleSvgAvatar = ({ color }: { color: string }) => (
    <svg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='30' cy='30' r='28.5' fill='#F1F1F1' stroke={color} strokeWidth='2' />
        <path
            d='M30.3135 34.8049C38.7126 34.9677 45.8484 39.0135 48.7705 44.6818C48.4339 45.1165 48.0829 45.5392 47.7178 45.9494C46.814 43.9327 45.3045 42.093 43.3008 40.5607C39.8932 37.9549 35.1202 36.3001 29.7871 36.3C24.4539 36.3 19.6802 37.9549 16.2725 40.5607C14.2688 42.093 12.7593 43.9327 11.8555 45.9494C11.4899 45.5388 11.1378 45.1161 10.8008 44.6809C13.7839 38.8945 21.1605 34.8 29.7871 34.8L30.3135 34.8049Z'
            fill={color}
        />
        <circle cx='29.9996' cy='21.8553' r='10.8551' stroke={color} strokeWidth='1.5' />
        <path
            d='M29.3271 35.5305C29.5188 35.3912 29.7701 35.3733 29.9766 35.4777L30.0615 35.5305L32.2471 37.1174C32.4386 37.2566 32.5325 37.4904 32.4971 37.7189L32.4736 37.8166L31.6387 40.385C31.555 40.6423 31.3156 40.8165 31.0449 40.8166H28.3438C28.0732 40.8164 27.8337 40.6423 27.75 40.385L26.915 37.8166C26.8314 37.5591 26.9235 37.2765 27.1426 37.1174L29.3271 35.5305Z'
            stroke={color}
            strokeWidth='0.75'
        />
        <line x1='28.1069' y1='40.4047' x2='26.1897' y2='51.5951' stroke={color} strokeWidth='0.75' />
        <line
            y1='-0.375'
            x2='11.4003'
            y2='-0.375'
            transform='matrix(0.190984 0.981593 0.981593 -0.190984 32.0029 40.3413)'
            stroke={color}
            strokeWidth='0.75'
        />
        <line x1='26.0726' y1='51.2543' x2='30.2527' y2='55.0556' stroke={color} strokeWidth='0.75' />
        <line
            y1='-0.375'
            x2='5.65001'
            y2='-0.375'
            transform='matrix(-0.739836 0.672787 0.672787 0.739836 34.1797 51.5317)'
            stroke={color}
            strokeWidth='0.75'
        />
    </svg>
);

export default MaleSvgAvatar;
